<script setup lang="ts">
  import SearchResultGroup from './search-result-group.vue'

  defineProps<{
    categories: SearchCategory[],
  }>()
</script>

<template>
  <search-result-group
    v-slot="{ item: category }"
    :items="categories"
    route-list="product category list"
    route-detail="product category edit"
    name="Kategori">
    <div class="text-sm font-medium">
      {{ category.name }}
    </div>
    <div class="mb-1 text-xs text-gray-600">
      {{ category.full_name }}
    </div>
    <div class="flex items-center text-xs gap-1.5">
      <div class="text-gray-500 mt-1">
        <fa-icon icon="i-far-list" />
      </div>
      <div>{{ category.children.length }} subkategori</div>
    </div>
  </search-result-group>
</template>
